import React, {useContext, useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { filter } from "lodash";
import { HolidayStatus, StatusBox } from "components";
import { Link } from "react-router-dom";
import { Button, Card, CardBody } from "reactstrap";
import EmployeeContext from "contexts/EmployeeContext";

const List = ({client, limit = false, match }) => {
    const [loans, setLoans] = useState();
    const [viewAllLoans, setViewAllLoans] = useState(true);
    const { employee } = useContext(EmployeeContext);

    useEffect(
        () =>
            void (async () => {
                if(!employee) return;
                const loans = await client
                    .get(`employees/${employee.id}/loans`)
                    .get("data");
                
                const active = filter(loans, (i) => {
                    if (i.approved === false) return false;
                    return !i.finished;
                });

                setLoans({
                    active,
                    all: loans,
                });
            })(),
        [employee]
    );

    if (!loans) return null;

    return (
        <div className="d-print-none inv-table">
            <Card className="shadow-sm border my-2">
                <CardBody>
                    <div className="row mb-3">
                        <div className="col-6">
                            <h5 className="d-print-none">
                                <Trans>Loans</Trans>
                            </h5>
                        </div>
                        <div className="col-6 text-right">
                            <Link
                                className="btn btn-primary btn-sm d-print-none"
                                to={`/employee_payroll/loans/${employee.id}/request_loan`} >
                                <Trans>New Loan Request</Trans>
                            </Link>
                        </div>
                    </div>

                    <div className="row">
                        <Button className="p-1 mb-2 btn btn-secondary"  onClick={() => setViewAllLoans(!viewAllLoans)} >
                            <Trans>View {viewAllLoans ? "Active" : "All"} Loans</Trans>
                        </Button>
                        <table className="table table-striped employee-holiday-table">
                            <thead>
                                <tr>
                                    <th className="font-weight-semibold p-2">
                                        <Trans>Amount</Trans>
                                    </th>
                                    <th className="font-weight-semibold p-2">
                                        <Trans>Monthly Deduction</Trans>
                                    </th>
                                    <th className="font-weight-semibold p-2">
                                        <Trans>Remaining Amount</Trans>
                                    </th>
                                    <th className="font-weight-semibold p-2">
                                        <Trans>Approval</Trans>
                                    </th>
                                    <th className="font-weight-semibold p-2">
                                        <Trans>Status</Trans>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="small">
                                {loans[viewAllLoans ? "all" : "active"].slice(0, limit || loans[viewAllLoans ? "all" : "active"].length).map((i) => (
                                    <tr key={i.id}>
                                        <td className="p-2">{i.total_amount}</td>
                                        <td className="p-2">{i.deduction_amount}</td>
                                        <td className="p-2">{i.remaining_amount}</td>
                                        <td className="p-2">
                                            <HolidayStatus approved={i.approved} />
                                        </td>
                                        <td className="p-2">
                                            {i.approved && <StatusBox status={i.status}>{i.status}</StatusBox>}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </CardBody>
            </Card>
        </div>
    );
};

export default List